







import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({})
export default class SubscribeButton extends Vue {
    @Prop({default: false})
    isSubscribed!: boolean;

    @Prop({default: '-'})
    amount!: number | string;

    get text() {
        return this.isSubscribed ? 'Subscribed' : 'Subscribe';
    }

    get icon() {
        return this.isSubscribed ? 'fa-check-circle' : 'fa-check';
    }
}

